// extracted by mini-css-extract-plugin
export default {"orderByNeutral":"OrderBySelected_orderByNeutral__LCl5s","iconNeutral":"OrderBySelected_iconNeutral__okwa7"};